import { useTranslation } from 'react-i18next'

import { Button } from './button'
import { SpainFlag, UKFlag } from './flags'

export function LanguageSwitchButton() {
    const { i18n } = useTranslation()

    // Normalize language to 'en' or 'es' (handle variants like 'es-ES', 'en-US', etc.)
    const currentLanguage = i18n.language?.startsWith('es') ? 'es' : i18n.language?.startsWith('en') ? 'en' : 'es'

    const toggleLanguage = () => {
        const newLanguage = currentLanguage === 'en' ? 'es' : 'en'
        i18n.changeLanguage(newLanguage)
    }

    return (
        <Button
            variant='outline'
            size='sm'
            className='flex h-[34px] min-w-[52px] items-center justify-center bg-accent p-1 font-semibold hover:bg-accent/80'
            onClick={toggleLanguage}
        >
            {currentLanguage === 'es' ? <SpainFlag /> : <UKFlag />}
        </Button>
    )
}
